import { TypeaheadBox, useApi } from "lcm-iot-commons";
import { useEffect } from "react";

type OwnProps = {
  name: string;
  tenantId?: number;
  manufacturerId?: number;
  excludeProductId?: number;
  initialValues?: $TSFixMe;
  setFieldValue: $TSFixMeFunction;
};

const defaultProps: Partial<OwnProps> = {
  // @ts-expect-error TS(2322) FIXME: Type 'null' is not assignable to type 'number | un... Remove this comment to see the full error message
  tenantId: null,
  // @ts-expect-error TS(2322) FIXME: Type 'null' is not assignable to type 'number | un... Remove this comment to see the full error message
  manufacturerId: null,
  // @ts-expect-error TS(2322) FIXME: Type 'null' is not assignable to type 'number | un... Remove this comment to see the full error message
  excludeProductId: null,
  initialValues: null,
};

type Props = OwnProps & typeof defaultProps;

export default function ProductTypeahead(props: Props) {
  const { tenantId, manufacturerId, excludeProductId } = props;
  const { initialValues, name, setFieldValue } = props;
  const api = useApi();
  let products: $TSFixMe = null;

  const { data: productsResponse, isFetching } = api.get.useQuery(
    "/products",
    {
      tenant_id: tenantId,
      manufacturer_id: manufacturerId,
    },
    { enabled: !!tenantId && !!manufacturerId },
  );

  let newResponse;

  useEffect(() => {
    if (
      initialValues?.manufacturer &&
      initialValues.manufacturer.id !== manufacturerId
    ) {
      setFieldValue(name, null);
    }
  }, [manufacturerId]);

  if (excludeProductId) {
    newResponse = productsResponse
      ? (productsResponse as $TSFixMe).products.filter(
          (product: $TSFixMe) => product.id !== excludeProductId,
        )
      : null;
  } else {
    newResponse = (productsResponse as $TSFixMe)?.products ?? null;
  }
  products = newResponse
    ? newResponse.map((product: $TSFixMe) => ({
        id: product.id,
        name: product.name ?? product.product_code,
      }))
    : null;

  return isFetching ? null : (
    // @ts-expect-error TS(2322) FIXME: Type '{ options: undefined; labelKey: string; name... Remove this comment to see the full error message
    <TypeaheadBox {...props} options={products} labelKey="name" />
  );
}

ProductTypeahead.defaultProps = defaultProps;
